import React from 'react'
import { useLocation } from 'react-router-dom'

import { DASHBOARD_STYLED_CONSTS, Dashboard } from '@components'
import { Tabs, useMediaQueryContext } from '@fourthwall/components'
import type { TabProps } from '@fourthwall/components/dist/common/Tabs/Tab/types'

import * as S from './NavTabs.styled'

type Props = {
  tabs: {
    label: string
    to?: string
    value?: string
  }[]
  activeTab?: string
  onTabClick?: (value: string) => void
}

export const NavTabs = ({ tabs, activeTab, onTabClick }: Props) => {
  const media = useMediaQueryContext()
  const { pathname } = useLocation()
  const mobileTabProps: Partial<TabProps> = !media.tablet
    ? {
        variant: 'dimmed',
        size: 'medium',
        weight: 'bold',
        scrollable: true,
        scrollIntoView: true,
        scrollIntoViewOffset: DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL,
      }
    : {}

  const findActiveTabIndex = () => {
    for (let i = 0; i < tabs.length; i++) {
      const tab = tabs[i]
      if (tab.to === pathname || pathname.startsWith(`${tab.to}/`)) {
        return i
      }
    }

    return 0
  }

  const defaultIndex = findActiveTabIndex()

  return (
    <Tabs direction="horizontal" defaultIndex={defaultIndex}>
      <Dashboard.Section.ScrollableContent hideScrollbar fullWidth>
        <Tabs.List direction="horizontal">
          {tabs.map(({ label, to, value }) => {
            const isActive = !!activeTab && activeTab === value

            return (
              <S.Tab
                key={label}
                to={to}
                name={label}
                selected={isActive}
                onClick={() => {
                  if (onTabClick && value) {
                    onTabClick(value)
                  }
                }}
                variant={isActive ? 'default' : 'dimmed'}
                direction="horizontal"
                size="large"
                {...mobileTabProps}
              />
            )
          })}
        </Tabs.List>
      </Dashboard.Section.ScrollableContent>
    </Tabs>
  )
}
